import { z } from "zod";

export const SSN_PATTERN = /^\d{3}-\d{2}-\d{4}$/;

export const ssnSchema = z.string().regex(SSN_PATTERN).brand<"Ssn">();
export type Ssn = z.infer<typeof ssnSchema>;
